export default {
	sources_index({ sources_index }) {
		return sources_index;
	},
};
